interface ApiConfig {
  API_URL: string;
}

interface Config {
  api: ApiConfig;
}

const API_URL =
  process.env.NODE_ENV === "development"
    ? "https://api-alerte.didodigit.com"
    : "https://api-alerte.didodigit.com";

const config: Config = {
  api: {
    API_URL,
  },
};

export default config;